export var PillSize;
(function (PillSize) {
    PillSize["Large"] = "large";
    PillSize["Medium"] = "medium";
    PillSize["Small"] = "small";
})(PillSize || (PillSize = {}));
export var PillType;
(function (PillType) {
    PillType["Danger"] = "danger";
    PillType["DangerAlt"] = "danger-alt";
    PillType["DangerDark"] = "danger-dark";
    PillType["Default"] = "default";
    PillType["DefaultAlt"] = "default-alt";
    PillType["DefaultDark"] = "default-dark";
    PillType["Info"] = "info";
    PillType["InfoAlt"] = "info-alt";
    PillType["InfoDark"] = "info-dark";
    PillType["Secondary"] = "secondary";
    PillType["SecondaryAlt"] = "secondary-alt";
    PillType["SecondaryDark"] = "secondary-dark";
    PillType["Success"] = "success";
    PillType["SuccessAlt"] = "success-alt";
    PillType["SuccessDark"] = "success-dark";
    PillType["Warning"] = "warning";
    PillType["WarningAlt"] = "warning-alt";
    PillType["WarningDark"] = "warning-dark";
})(PillType || (PillType = {}));
//# sourceMappingURL=types.js.map